import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { matchPath, useNavigate } from "react-router-dom";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import { UserContext } from "../UserContext";
import { Router } from "./Router";
import { MobileSidebarMenu } from "./SidebarMenu/MobileSidebarMenu";
import { SidebarMenu } from "./SidebarMenu/SidebarMenu";
import { TopBar } from "./TopBar/TopBar";

export const MainpageContainer = () => {
	const navigate = useNavigate();
	const { user, setUser, selectedLocation } = useContext(UserContext);
	const isEmpty = user === null;
	const [hideElements, setHideElements] = useState(false);

	const {ApiCall}
		= useContext(ApiContext);

	const match = matchPath(
		{
			path: "/details",
			exact: true,
			strict: true
		},
		location.pathname
	);

	useEffect(() => {
		if (match?.pathname === location.pathname) setHideElements(true);
		else setHideElements(false);
	}, [location]);

	useEffect(() => {
		if (
			// prevent navigation loop for new user
			selectedLocation != null &&
			// first check if location billing is missing.
			(selectedLocation.billing === undefined ||
				selectedLocation.billing?.business_id === undefined ||
				selectedLocation.billing?.customer_name === undefined ||
				selectedLocation.billing?.invoice_address === undefined ||
				selectedLocation.billing?.invoice_operator === undefined ||
				selectedLocation.billing === null ||
				selectedLocation.billing?.business_id === null ||
				selectedLocation.billing?.customer_name === null ||
				selectedLocation.billing?.invoice_address === null ||
				selectedLocation.billing?.invoice_operator === null)
		)
			if (
				// if billing is missing then check url path to block navigation via url and redirect to location page
				location.pathname !==
					`/locations/${selectedLocation.id}` &&
				location.pathname !== "/locations"
			)
				navigate("/");
			else return;
	}, [selectedLocation]);

	useEffect(() => {
		const getToken = document.cookie.split("webapp-token=")[1];

		// prevent fetching user data if token is undefined
		if (getToken === undefined) {
			navigate("/login");
		} else if (user == null)
			ApiCall("GET", "user")
				.then((res) => {
					setUser(res);
				})
				.catch((err) => {
					console.log(err);
				});
	}, []);

	return (
		<>
		{(
			<Grid
			container
			sx={{
				display: "grid",
				gridTemplateRows: "120px repeat(1,1fr)",
				gridTemplateColumns: "170px repeat(1,1fr)",
				gap: "0px 0px",
				backgroundColor: ColorScheme.background,
				color: ColorScheme.secondary,
				minHeight: "inherit",
				width: isMobile ? "100dvw" : "100vw",
				height: isMobile ? "100%" : "100vh"
			}}
		>
			{!isMobile && (
				<Grid
					item
					sx={{
						display: hideElements && "none",
						position: "fixed",
						gridArea: "1/1/3/2"
					}}
				>
					{!isEmpty && <SidebarMenu />}
				</Grid>
			)}

			<Grid
				item
				sx={{
					display: hideElements ? "none" : "flex",
					gridArea: isMobile ? "1/1/1/2" : "1/2/2/2",
					width: isMobile ? "95dvw" : "100%",
					px: "4%"
				}}
			>
				{isMobile && <MobileSidebarMenu />}

				<TopBar title={"Test"} />
			</Grid>

			<Grid
				item
				sx={{
					gridArea: hideElements
						? "auto"
						: isMobile
							? "2/1/3/3"
							: "2/2/3/3",
					width: isMobile ? "100dvw" : hideElements ? "95%" : "95%",
					height: isMobile ? "100dvh" : "calc(100vh - 120px)", // space reserved for footer, currently not in use, but keep it to push more empty space between last content and end
					overflow: "scroll",
					scrollbarWidth: "none",
					padding: !isMobile ? "6%" : "4%",
					paddingBottom: isMobile ? "200px" : "6%"
				}}
			>
				<Router />
			</Grid>
		</Grid>
		)}
		</>
	);
};
